import { DateTimePart, TimeUnitUtils, useTimezone } from '@mews/framework';
import { useRepositoryQueries } from '@mews-commander/data-access';
import { Interval } from '@mews-commander/types';
import { useServiceInfo } from '@mews-commander/legacy-entities/src/utils/useServiceInfo';
import { getServiceOperationalInterval } from '@mews-commander/legacy-entities/src/ducks/servicesNew';

export function useServiceAvailabilityQueries<T extends Interval>(serviceId: string, intervals: Array<T> | null) {
    const timezone = useTimezone();
    const { bookableService } = useServiceInfo(serviceId);
    let startOffset: string | undefined;
    let endOffset: string | undefined;
    let timePart: DateTimePart | undefined;

    if (bookableService) {
        startOffset = bookableService.data.value.startOffset; // eslint-disable-line
        endOffset = bookableService.data.value.endOffset; // eslint-disable-line
        timePart = TimeUnitUtils.timeUnitToDateTimePart(bookableService.data.value.timeUnitPeriod);
    }

    return useRepositoryQueries(
        'services',
        'getAvailabilities',
        intervals?.map((interval) => ({
            serviceId,
            ...(bookableService
                ? getServiceOperationalInterval(interval, bookableService, timezone)
                : { firstTimeUnitStartUtc: '', lastTimeUnitStartUtc: '' }),
        })) ?? [],
        {
            enabled: !!(intervals?.length && bookableService && startOffset && endOffset && timePart),
        }
    );
}
